<template>
    <div id="pricing_action_modal" class="modal pricing-action-modal">
        <div class="modal-background pricing-action-backdrop"></div>
        <div class="modal-card pricing-action-card">
            <header class="modal-card-head pricing-action-head">
                <p class="modal-card-title pricing-action-title">Pricing Action</p>
            </header>
            <section class="modal-card-body pricing-action-body">
                <p class="pricing-action-description">{{ paDescription }}</p>
                <table class="table pricing-action-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Yours</th>
                            <th>Suggested</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Margin</td>
                            <td>{{ formatNumber(qMargin, '0,0,0,0,0.0') + '%' }}</td>
                            <td class="pricing-action-suggested">{{ formatNumber(paSuggestedMargin, '0,0,0,0,0.0%') }}</td>
                        </tr>
                        <tr>
                            <td>Price</td>
                            <td>{{ formatNumber(qQuote, '$0,0,0,0,0.00') }}</td>
                            <td class="pricing-action-suggested">{{ formatNumber(paSuggestedPrice, '$0,0,0,0,0.00') }}</td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <footer class="modal-card-foot pricing-action-foot">
                <button class="pricing-action-button pricing-action-button--primary" @click="doUseSuggestedPrice()">
                    Use suggested price
                </button>
                <button class="pricing-action-button pricing-action-button--secondary" @click="doEditPriceManually()">
                    Edit price manually
                </button>
                <button class="pricing-action-button pricing-action-button--danger" @click="doContinueWithYourPrice()">
                    Continue with your price
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import numeral from 'numeral'

export default {
    name: 'PricingActionModal',
    props: {
        paDescription: {
            type: String,
            required: false,
            default: ''
        },
        qMargin: {
            type: String,
            required: false,
            default: ''
        },
        paSuggestedMargin: {
            type: String,
            required: false,
            default: ''
        },
        qQuote: {
            type: String,
            required: false,
            default: ''
        },
        paSuggestedPrice: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        formatNumber(value, format) {
            return numeral(value).format(format)
        },
        doUseSuggestedPrice() {
            this.$emit('doUseSuggestedPrice')
        },
        doEditPriceManually() {
            this.$emit('doEditPriceManually')
        },
        doContinueWithYourPrice() {
            this.$emit('doContinueWithYourPrice')
        }
    }
}
</script>

<style scoped>
.pricing-action-modal {
    z-index: var(--shell-modal-z, 1090);
}

.pricing-action-backdrop {
    background: var(--color-surface-overlay);
    backdrop-filter: blur(2px);
}

.pricing-action-card {
    width: min(560px, calc(100vw - 32px));
    max-height: calc(100vh - 48px);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md);
    overflow: hidden;
    background: var(--color-surface-canvas);
    color: var(--color-text-primary);
    box-shadow: var(--shadow-xl);
}

.pricing-action-head,
.pricing-action-foot {
    background: var(--color-surface-canvas);
    border-color: var(--color-border-muted);
}

.pricing-action-head {
    padding: 1rem 1.25rem;
}

.pricing-action-title {
    color: var(--color-text-primary);
    font-size: 1.05rem;
    font-weight: 700;
}

.pricing-action-body {
    padding: 1rem 1.25rem 1.25rem;
    background: var(--color-surface-canvas);
    color: var(--color-text-primary);
}

.pricing-action-description {
    margin: 0 0 1rem;
    color: var(--color-text-secondary);
    line-height: 1.45;
}

.pricing-action-table {
    width: 100%;
    margin: 0;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--color-border-muted);
    border-radius: var(--radius-sm);
    overflow: hidden;
    background: var(--color-surface-canvas);
    color: var(--color-text-primary);
}

.pricing-action-table th,
.pricing-action-table td {
    padding: 0.75rem;
    border-color: var(--color-border-muted);
    background: var(--color-surface-canvas);
    color: var(--color-text-primary);
}

.pricing-action-table th {
    background: var(--color-surface-inverse);
    color: var(--color-text-inverse);
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
}

.pricing-action-table tbody tr:nth-child(even) td {
    background: var(--color-table-stripe);
}

.pricing-action-suggested {
    color: var(--color-state-info-strong) !important;
    font-weight: 800;
}

.pricing-action-foot {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding: 1rem 1.25rem;
}

.pricing-action-button {
    min-height: 2.35rem;
    min-width: 9.5rem;
    padding: 0.45rem 0.85rem;
    border: 1px solid transparent;
    border-radius: var(--radius-sm);
    font-weight: 700;
    line-height: 1.2;
    transition:
        transform 0.15s ease,
        box-shadow 0.15s ease,
        background-color 0.15s ease,
        border-color 0.15s ease;
}

.pricing-action-button:hover:not(:disabled),
.pricing-action-button:focus:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: var(--shadow-sm);
}

.pricing-action-button:focus {
    outline: none;
    box-shadow: var(--shadow-focus-brand);
}

.pricing-action-button:disabled {
    cursor: not-allowed;
    opacity: 0.55;
    transform: none;
    box-shadow: none;
}

.pricing-action-button--primary {
    background: var(--color-state-success);
    border-color: var(--color-state-success);
    color: var(--color-text-inverse);
}

.pricing-action-button--primary:hover,
.pricing-action-button--primary:focus {
    background: var(--color-state-success-strong);
    border-color: var(--color-state-success-strong);
}

.pricing-action-button--secondary {
    background: var(--color-surface-subtle);
    border-color: var(--color-border-default);
    color: var(--color-text-primary);
}

.pricing-action-button--secondary:hover,
.pricing-action-button--secondary:focus {
    border-color: var(--color-border-accent-strong);
}

.pricing-action-button--danger {
    background: transparent;
    border-color: var(--color-brand-primary);
    color: var(--color-brand-primary);
}

.pricing-action-button--danger:hover,
.pricing-action-button--danger:focus {
    background: var(--color-brand-primary-soft, var(--color-accent-soft));
}

@media (max-width: 640px) {
    .pricing-action-foot {
        flex-direction: column;
    }

    .pricing-action-button {
        width: 100%;
    }
}
</style>
